import {
  PurchaseOrderProductLineItem,
  UpsertPurchaseOrderProductStock,
} from '../../../../clients/quipli-service/purchase-order/purchase-order';
import { Field, FieldDescription } from '../../../../components/field/field';
import { Typography } from '../../../../components/typography/typography';

export const QuantityProductForm = ({
  purchaseOrderProduct,
  stock,
  onUpdate,
  markFieldAsTouched,
  isFieldTouched,
  errors = {},
}: {
  purchaseOrderProduct: PurchaseOrderProductLineItem;
  stock: UpsertPurchaseOrderProductStock;
  onUpdate: (stock: UpsertPurchaseOrderProductStock) => void;
  markFieldAsTouched: (fieldName: string) => void;
  isFieldTouched: (fieldName: string) => boolean;
  errors?: Record<string, string>;
}) => {
  const isQuantityTouched = isFieldTouched('saleQuantity') && isFieldTouched('rentalQuantity');
  const quantityError = errors['quantity'];

  const updateQuantity = (fieldName: 'saleQuantity' | 'rentalQuantity', value: string) => {
    markFieldAsTouched(fieldName);
    onUpdate({ ...stock, [fieldName]: parseFloat(value || '0') });
  };

  return (
    <div className="flex flex-column gap-2">
      <div className="flex gap-4 items-start justify-between mb-2">
        <div className="flex gap-2 flex-wrap">
          <Typography type="text-md" weight="medium" className="text-grey-700">
            Product:
          </Typography>
          <Typography type="text-md" className="text-quipli-black-500">
            {purchaseOrderProduct.product.name}
          </Typography>
        </div>
        <div className="flex gap-2 shrink-0">
          <Typography type="text-md" weight="medium" className="text-grey-700">
            Quantity:
          </Typography>
          <Typography type="text-md" className="text-quipli-black-500" data-cy="quantity-product-form-quantity">
            {purchaseOrderProduct.quantity}
          </Typography>
        </div>
      </div>

      {/* Fields */}
      {purchaseOrderProduct.product.allowSale && (
        <Field
          type="number"
          label="Sale Quantity"
          dataCy="quantity-product-form-sale-quantity"
          value={stock.saleQuantity}
          onChange={(v) => {
            updateQuantity('saleQuantity', v);
          }}
          disabled={!purchaseOrderProduct.product.allowRent}
          invalid={isQuantityTouched && !!quantityError}
        />
      )}
      {purchaseOrderProduct.product.allowRent && (
        <Field
          type="number"
          label="Rental Quantity"
          dataCy="quantity-product-form-rental-quantity"
          value={stock.rentalQuantity}
          onChange={(v) => {
            updateQuantity('rentalQuantity', v);
          }}
          disabled={!purchaseOrderProduct.product.allowSale}
          invalid={isQuantityTouched && !!quantityError}
        />
      )}
      {/* Just one error message for both fields since they are related */}
      {isQuantityTouched && quantityError && <FieldDescription description={quantityError} invalid />}
    </div>
  );
};
